import { render, staticRenderFns } from "./WarningConfig.vue?vue&type=template&id=7cc6a176&scoped=true&"
import script from "./WarningConfig.vue?vue&type=script&lang=js&"
export * from "./WarningConfig.vue?vue&type=script&lang=js&"
import style0 from "./WarningConfig.vue?vue&type=style&index=0&id=7cc6a176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6a176",
  null
  
)

export default component.exports